import { Box } from "@mui/material";
import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import { memo, useRef } from "react";
import "./TermsAndConditions.css";
import useSessionStorage from "@mirage/hooks/useSessionStorage";

const TermsAndConditions = memo(() => {
    const [sessionStorage] = useSessionStorage("publicportal");
    const wrapperRef = useRef<HTMLDivElement>(null);
    const content = sessionStorage?.clientSettings?.TERMS_AND_CONDITIONS || `<h1>NO TERMS PROVIDED</h1>`;
    if (wrapperRef?.current) {
        wrapperRef.current.innerHTML = content;
    }
    return (
        <>
            <BigLogo />
            <Board size="big" headerText="Terms and conditions" className="terms-and-conditions-board">
                <Box ref={wrapperRef} paddingX="1rem" />
            </Board>
        </>
    );
});

export default TermsAndConditions;
